/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteTimelineEtaDtoBase
 * auto generated base class for the model RouteTimelineEtaDtoModel.
 */
export const RouteTimelineEtaDtoModelBase = ModelBase
  .named('RouteTimelineEtaDto')
  .props({
    __typename: types.optional(types.literal("RouteTimelineEtaDto"), "RouteTimelineEtaDto"),
    id: types.identifier,
    routeTimelineId: types.union(types.undefined, types.number),
    expectedArrivalTime: types.union(types.undefined, types.null, types.string),
    expectedFinishTime: types.union(types.undefined, types.null, types.string),
    originalArrivalTime: types.union(types.undefined, types.null, types.string),
    originalFinishTime: types.union(types.undefined, types.null, types.string),
    actualArrivalTime: types.union(types.undefined, types.null, types.string),
    actualFinishTime: types.union(types.undefined, types.null, types.string),
    updatedOn: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTimelineEtaDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeTimelineId() { return this.__attr(`routeTimelineId`) }
  get expectedArrivalTime() { return this.__attr(`expectedArrivalTime`) }
  get expectedFinishTime() { return this.__attr(`expectedFinishTime`) }
  get originalArrivalTime() { return this.__attr(`originalArrivalTime`) }
  get originalFinishTime() { return this.__attr(`originalFinishTime`) }
  get actualArrivalTime() { return this.__attr(`actualArrivalTime`) }
  get actualFinishTime() { return this.__attr(`actualFinishTime`) }
  get updatedOn() { return this.__attr(`updatedOn`) }
}
export function selectFromRouteTimelineEtaDto() {
  return new RouteTimelineEtaDtoModelSelector()
}

export const routeTimelineEtaDtoModelPrimitives = selectFromRouteTimelineEtaDto().routeTimelineId.expectedArrivalTime.expectedFinishTime.originalArrivalTime.originalFinishTime.actualArrivalTime.actualFinishTime.updatedOn
